/**
 * "The recipient pressed Accept and was sent to sign in" for ONE invitation token, kept in
 * `sessionStorage` across the sign-in round trip. It is never read from the URL: a crafted link
 * must not be able to count as consent. Storage can be blocked; then the recipient just presses
 * Accept again after signing in.
 */
const KEY = 'people-access:invitation-confirm';

const storage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

/** Remember that `token` was confirmed before going to sign in. */
export const rememberConfirmation = (token) => {
  try {
    storage()?.setItem(KEY, token);
  } catch {
    // Blocked storage: the confirmation is simply not remembered.
  }
};

/** Whether `token` was confirmed before the sign-in (does not clear it). */
export const hasRememberedConfirmation = (token) => {
  try {
    return storage()?.getItem(KEY) === token;
  } catch {
    return false;
  }
};

/** Forget any remembered confirmation. */
export const forgetConfirmation = () => {
  try {
    storage()?.removeItem(KEY);
  } catch {
    // Nothing to forget.
  }
};
